import React, { useEffect, useState, useRef, useCallback } from 'react'
import Table from './partials/Table'
import Api from '../../../_helpers/Api'
import Pagination from '../../Pagination'
import { useHistory, useLocation } from 'react-router-dom'
import { fromInfo, trans } from '../../../_providers/Translation'

//modals
import AddOrEdit from './partials/AddOrEdit'
import Question from '../../modals/messages/Question'
import Filter from './partials/Filter'
import Skeleton from 'react-loading-skeleton'
import Tabs from './partials/Tabs'
import Help from '../../partials/Help'
import FilterTabs from '../contractors/partials/FilterTabs'
import Contracts from '../../modules/contracts/Index'
import { CONTRACT_TYPES } from '../../modules/contracts/config'

function Index() {

    const history = useHistory()
    const location = useLocation()

    const searchParams = new URLSearchParams(location.search)

    const modalAddOrEditRef = useRef(null)
    const modalQuestionRef = useRef(null)
    const contractsRef = useRef(null)

    const pageTabs = [
        { id: 'main', name: trans('tabs.mainData') },
        { id: 'contracts', name: trans('tabs.contracts') },
    ]

    const currentTab = pageTabs.find(t => t.id === searchParams.get('tab')) ? searchParams.get('tab') : pageTabs[0].id

    const handlePageTab = id => {
        searchParams.set('tab', id)

        history.push('?' + searchParams.toString())
    }

    const [state, setState] = useState({
        loading: true,
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {
            group: 'external'
        },
        update: false,
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                name: searchParams.get('name') || '',
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {
        if (state.setFilter) {
            searchParams.set('page', state.page)

            Object.entries(state.filter).map(filter => {
                searchParams.set(filter[0], filter[1])
            })

            history.push('?' + searchParams.toString())
        }

    }, [state.setFilter])

    useEffect(() => {
        // Списъкът с договори се зарежда от своя модул - няма смисъл да дърпаме
        // и външните техници, докато сме на другия таб.
        if (state.update && currentTab === 'main') {
            loadData()
        }
    }, [state.update, currentTab])

    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'partners/selfemployed/all?page=' + state.page

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages
                }))
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    // create
    const handleAdd = () => {
        if (currentTab === 'contracts') {
            contractsRef.current && contractsRef.current.add()
            return
        }

        modalAddOrEditRef.current.add()
    }

    const handleCreate = () => {
        handleRefresh()
    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    const handleUpdate = employee => {
        handleRefresh()
    }

    // delete
    const handleDelete = id => {
        Api.post('partners/employees/remove', {
            id: id
        }).then(res => {
            if (res.data.success) {
                handleRefresh()
            }
        })
    }

    const handleRefresh = () => {
        setState(prev => ({
            ...prev,
            page: 1,
            update: new Date().getTime()
        }))
    }

    // Question modal
    const handleOpenQuestion = id => {
        modalQuestionRef.current.open(id)
    }

    let timeout

    // Search
    const handleSearch = (key, val) => {
        clearTimeout(timeout)

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }))

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    const handlePage = page => {
        setState(prev => ({ ...prev, page: page.selected + 1, setFilter: new Date().getTime() }))
    }

    const handleTab = tab => {
        handleSearch('group', tab)

        setTimeout(() => {
            history.push('/relationships?group=' + tab)
        }, 500)
    }


    return (
        <>
            <AddOrEdit
                ref={modalAddOrEditRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
                handleRefresh={handleRefresh}
            />

            <Question
                ref={modalQuestionRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
                callback={handleDelete}
            />

            <div className="wrapper">
                <div className="top-part">
                    <div className="left">
                        <h1 className="page-heading">
                            {trans('headings.relationships')} <Help modalStyle={{ maxWidth: '600px' }}>{fromInfo('relationships')}</Help>
                        </h1>
                        <p className="page-subheading">
                            {trans('subheadings.relationships')}
                        </p>
                    </div>
                    <div className="right">
                        <div className="row">
                            <button className="button button-add" onClick={handleAdd}>
                                {trans('buttons.add')}
                            </button>
                        </div>
                    </div>
                </div>
                {/*
                <Tabs
                    tab={state.filter.group}
                    handleTab={handleTab}
                /> */}

                <FilterTabs
                    tabs={pageTabs}
                    tab={currentTab}
                    handleTab={handlePageTab}
                />

                {currentTab === 'contracts' &&
                    <Contracts
                        ref={contractsRef}
                        typeId={CONTRACT_TYPES.EXTERNAL}
                    />
                }

                {currentTab === 'main' &&
                <div className='pannel'>
                    <h3>
                        {trans('headings.externalEmployeesList')}
                    </h3>
                    <Filter
                        handleSearch={handleSearch}
                        name={state.filter.name}
                    />

                    {/* <div className="filter-standard">
                        <div className="col" data-id="1">
                            <input
                                type="search"
                                name="search"
                                placeholder={trans('random.search')}
                                value={state.filter.search}
                                onChange={handleSearch}
                            />
                        </div>
                    </div> */}
                    <hr />
                    {state.loading
                        ?
                        <Skeleton height={45} count={10} />
                        :
                        <>
                            <Table
                                tab={state.filter.group}
                                data={state.data}
                                loading={state.loading}
                                handleEdit={handleEdit}
                                handleDelete={handleOpenQuestion}
                            />

                            <Pagination
                                pages={state.pages}
                                page={state.page}
                                handlePage={handlePage}
                            />
                        </>
                    }
                </div>
                }

            </div>
        </>
    )
}

export default Index